export default __webpack_public_path__ + "static/icon-acquisition-agency-b9e2d0c0513d84de60d7f22b83409dc1.png";